function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "Email_svg__24_a"
}, React.createElement("stop", {
  stopColor: "#4DB1FD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#148CFC",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "url(#Email_svg__24_a)",
  cx: 13,
  cy: 13,
  r: 13
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.378 10.625l7.107 4.266a1 1 0 001.03 0l7.106-4.265a.25.25 0 01.379.215V17a2 2 0 01-2 2H7a2 2 0 01-2-2v-6.16a.25.25 0 01.378-.215zM19 7a2 2 0 011.737 1.007 1 1 0 01-.35 1.36l-6.872 4.124a1 1 0 01-1.03 0L5.615 9.37a1 1 0 01-.357-1.352A2 2 0 017 7h12z",
  fill: "#FFF"
});

var SvgEmail = function SvgEmail(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 26 26"
  }, props), _ref, _ref2, _ref3);
};

export default SvgEmail;